module.exports = __webpack_public_path__ + "img/shogi_2021_pack_4_0009.4d7a3194.png";